function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


/* CHACIN FYRE V58 — Home first without changing Shopify Liquid menu loops */
document.addEventListener('DOMContentLoaded', function () {
  function moveHomeFirst(list) {
    if (!list) return;
    var links = Array.prototype.slice.call(list.children);
    var homeItem = links.find(function (item) {
      var a = item.querySelector('a');
      if (!a) return false;
      var label = (a.textContent || '').trim().toLowerCase();
      var href = (a.getAttribute('href') || '').replace(/\/+$/, '') || '/';
      return label === 'home' || href === '/';
    });
    if (homeItem && list.firstElementChild !== homeItem) {
      list.insertBefore(homeItem, list.firstElementChild);
    }
  }

  document.querySelectorAll('.header__inline-menu > ul, .menu-drawer__navigation > ul').forEach(moveHomeFirst);
});


/* CHACIN FYRE V59 — bring Customer Favorites closer to the shopping categories */
document.addEventListener('DOMContentLoaded', function () {
  var headings = Array.prototype.slice.call(document.querySelectorAll('h1,h2,h3,.title'));
  var favHeading = headings.find(function (el) {
    return (el.textContent || '').trim().toLowerCase().indexOf('customer favorites') !== -1;
  });
  if (!favHeading) return;

  var favSection = favHeading.closest('.shopify-section, section');
  if (!favSection) return;
  favSection.classList.add('cf-customer-favorites');

  var candidates = Array.prototype.slice.call(document.querySelectorAll('.shopify-section, section'));
  var target = candidates.find(function (section) {
    var t = (section.textContent || '').toLowerCase();
    return t.indexOf('party favors') !== -1 &&
           t.indexOf('party bundles') !== -1 &&
           (t.indexOf('rush order') !== -1 || t.indexOf('custom order') !== -1);
  });

  if (target && target !== favSection && target.parentNode) {
    target.parentNode.insertBefore(favSection, target.nextSibling);
  }
});

/* V60 complete events, injected into existing pages without Liquid changes */
document.addEventListener('DOMContentLoaded',function(){var p=(location.pathname||'').replace(/\/$/,'');var m=document.querySelector('main#MainContent,#MainContent,main');if(!m||m.querySelector('[data-cf-v60]'))return;var h=null;if(p==='/pages/page-event-planning')h="<section class=\"cf-events-v60\" data-cf-v60><p class=\"cf-events-kicker\">Chacin Fyre Events</p><h2>Planning, Coordination &amp; Event Styling</h2><p>From the first idea to the final details, Chacin Fyre Events can help bring your celebration together. <strong>Services vary by package. Only services specifically listed in your selected package, proposal, invoice, or service agreement are included.</strong></p><div class=\"cf-events-grid\">\n<div class=\"cf-events-card\"><h3>Event Consultation / Planning Session</h3><p class=\"cf-events-price\">$125</p></div><div class=\"cf-events-card\"><h3>Vendor Sourcing &amp; Coordination Only</h3><p class=\"cf-events-price\">$350+</p></div>\n<div class=\"cf-events-card\"><h3>Partial Event Planning</h3><p class=\"cf-events-price\">$650+</p></div><div class=\"cf-events-card\"><h3>Full Event Planning</h3><p class=\"cf-events-price\">$950+</p></div>\n<div class=\"cf-events-card\"><h3>Full Planning + Day-of Coordination</h3><p class=\"cf-events-price\">$1,250+</p></div><div class=\"cf-events-card\"><h3>Day-of Coordination Only</h3><p class=\"cf-events-price\">$500+</p></div>\n<div class=\"cf-events-card cf-events-wide\"><h3>Custom Event Design / Styling Plan</h3><p class=\"cf-events-price\">$300+</p></div>\n<div class=\"cf-events-card\"><h3>Full Planning May Include</h3><ul><li>Theme/concept development</li><li>Vendor research and sourcing</li><li>Quote comparisons</li><li>Vendor communication</li><li>Food and dessert coordination</li><li>Rentals and entertainment</li><li>Timeline/checklist</li><li>Payment/deadline tracking</li><li>Overall logistics</li></ul></div>\n<div class=\"cf-events-card\"><h3>Rush Planning</h3><ul><li>Within 30 days: +25%</li><li>Within 14 days: +40%</li><li>Within 7 days: +50%</li></ul><p>Subject to availability.</p></div>\n<div class=\"cf-events-card\"><h3>Travel</h3><p>Base packages are South Florida/local. Out-of-area events may require airfare or mileage, hotel, rental car/Uber/local transportation, baggage, parking/tolls and necessary travel expenses paid in advance, plus a travel coordination fee starting around $350. Chacin Fyre does not finance client travel or vendor costs.</p></div>\n<div class=\"cf-events-card\"><h3>Booking &amp; Payment</h3><p>A 50% <strong>non-refundable booking retainer</strong> reserves the date. Remaining 50% is due 7 days before the event unless the written agreement says otherwise. Vendor costs are paid by the client and separate from the planning fee.</p></div>\n<div class=\"cf-events-card cf-events-wide\"><h3>Custom Chacin Fyre Products</h3><p>Cups, plates, favors, signs, cutouts, invitations, websites/RSVP pages, activity books, cake toppers and other custom products are separate unless specifically included in your proposal.</p></div></div>\n<div class=\"cf-events-note\">Pricing shown represents starting prices. Final pricing is based on event scope, location, timeline and requested services. Your date is not confirmed until your service agreement is accepted and the required non-refundable booking retainer is paid.</div>\n<a class=\"cf-events-btn\" href=\"/pages/event-planning-inquiry\">Request a Quote</a><a class=\"cf-events-btn alt\" href=\"/pages/event-planning-policies\">Policies &amp; Terms</a><p>Chacin Fyre Events is a service of Chacin Fyre, LLC.</p></section>";if(p==='/pages/event-planning-policies')h="<section class=\"cf-events-v60\" data-cf-v60><p class=\"cf-events-kicker\">Chacin Fyre Events</p><h2>Event Planning Policies &amp; Terms</h2><div class=\"cf-events-grid\">\n<div class=\"cf-events-card\"><h3>Booking Retainer</h3><p>50% non-refundable booking retainer required to reserve the event date.</p></div><div class=\"cf-events-card\"><h3>Final Payment</h3><p>Remaining 50% due 7 days before the event unless a written agreement states otherwise.</p></div>\n<div class=\"cf-events-card\"><h3>Cancellations &amp; Rescheduling</h3><p>The booking retainer is non-refundable. Rescheduling is subject to availability, the service agreement and applicable vendor policies.</p></div><div class=\"cf-events-card\"><h3>Rush Planning</h3><p>+25% within 30 days, +40% within 14 days, +50% within 7 days, subject to availability.</p></div>\n<div class=\"cf-events-card\"><h3>Vendor Payments &amp; Third Parties</h3><p>Vendor costs are separate unless specifically stated. Independent vendors remain responsible for their products, services, staffing, policies and performance.</p></div><div class=\"cf-events-card\"><h3>Travel</h3><p>Out-of-area events may require advance payment of travel expenses plus a travel coordination fee starting around $350.</p></div>\n<div class=\"cf-events-card\"><h3>Custom Products</h3><p>Custom Chacin Fyre products are separate unless specifically included in the proposal, invoice or agreement.</p></div><div class=\"cf-events-card\"><h3>Changes</h3><p>Changes to scope, design, guest count, venue, timeline or services may affect pricing, deadlines and vendor availability.</p></div>\n<div class=\"cf-events-card\"><h3>Client Responsibilities</h3><p>Clients must provide timely approvals, accurate event information, venue details and required payments.</p></div><div class=\"cf-events-card\"><h3>Event-Day Hours &amp; Overtime</h3><p>Included hours are stated in the selected package/agreement. Additional time may be billed when applicable.</p></div>\n<div class=\"cf-events-card\"><h3>Weather / Force Majeure</h3><p>Severe weather, emergencies, venue closures and circumstances outside reasonable control are handled under the service agreement and vendor policies.</p></div><div class=\"cf-events-card\"><h3>Damage / Loss</h3><p>Responsibility for rented items, property or event-site damage follows applicable rental/vendor terms and the service agreement.</p></div>\n<div class=\"cf-events-card\"><h3>Photos / Marketing</h3><p>Permission to use event photos or video for marketing is separate and is not assumed by booking planning services.</p></div><div class=\"cf-events-card\"><h3>Acceptance</h3><p>Your date is not confirmed until the agreement is accepted and the required booking retainer is paid.</p></div></div>\n<div class=\"cf-events-note\"><strong>Services vary by package. Only services specifically listed in your selected package, proposal, invoice, or service agreement are included.</strong></div><a class=\"cf-events-btn\" href=\"/pages/event-planning-inquiry\">Request a Quote</a><a class=\"cf-events-btn alt\" href=\"/pages/page-event-planning\">Planning Services</a><p>Chacin Fyre Events is a service of Chacin Fyre, LLC.</p></section>";if(p==='/pages/event-planning-inquiry')h="<section class=\"cf-events-v60\" data-cf-v60><p class=\"cf-events-kicker\">Chacin Fyre Events</p><h2>Request an Event Planning Quote</h2><div class=\"cf-events-note\">Submitting this form is a request for event-planning services and does not reserve your event date. Pricing shown on the website represents starting prices. Final pricing is based on event scope, location, timeline and requested services. Your date is not confirmed until your service agreement is accepted and the required non-refundable booking retainer is paid.</div>\n<form method=\"post\" action=\"/contact#ContactForm\" accept-charset=\"UTF-8\"><input type=\"hidden\" name=\"form_type\" value=\"contact\"><input type=\"hidden\" name=\"utf8\" value=\"\u2713\"><input type=\"hidden\" name=\"contact[Subject]\" value=\"Event Planning Inquiry\"><div class=\"cf-event-form\">\n<div><label>Name *</label><input required name=\"contact[Name]\"></div><div><label>Email *</label><input required type=\"email\" name=\"contact[email]\"></div><div><label>Phone</label><input name=\"contact[Phone]\"></div><div><label>Preferred Contact</label><select name=\"contact[Preferred Contact]\"><option>Email</option><option>Phone</option><option>Text</option></select></div>\n<div><label>Event Type</label><input name=\"contact[Event Type]\"></div><div><label>Event Date</label><input type=\"date\" name=\"contact[Event Date]\"></div><div><label>Start Time</label><input type=\"time\" name=\"contact[Start Time]\"></div><div><label>End Time</label><input type=\"time\" name=\"contact[End Time]\"></div>\n<div class=\"wide\"><label>Venue Name / Address</label><input name=\"contact[Venue]\"></div><div><label>Venue Status</label><select name=\"contact[Venue Status]\"><option>Already booked</option><option>Considering</option><option>Need help</option><option>Home/private</option></select></div><div><label>City / State</label><input name=\"contact[City State]\"></div>\n<div><label>Local or Travel</label><select name=\"contact[Local or Travel]\"><option>South Florida / Local</option><option>Travel / Out of Area</option><option>Not sure</option></select></div><div><label>Guest Count</label><input type=\"number\" name=\"contact[Guest Count]\"></div><div><label>Estimated Children</label><input type=\"number\" name=\"contact[Children Count]\"></div>\n<div class=\"wide\"><label>Theme / Colors / Vision</label><textarea name=\"contact[Theme Colors Vision]\"></textarea></div><div><label>Total Event Budget</label><select name=\"contact[Budget]\"><option>Under $1,500</option><option>$1,500\u2013$2,500</option><option>$2,500\u2013$5,000</option><option>$5,000\u2013$7,500</option><option>$7,500\u2013$10,000</option><option>$10,000+</option></select></div>\n<div><label>Does budget include Chacin Fyre planning fee?</label><select name=\"contact[Budget Includes Planning Fee]\"><option>Yes</option><option>No</option><option>Not sure</option></select></div><div class=\"wide\"><label>Service Interested In</label><select name=\"contact[Service]\"><option>Consultation</option><option>Vendor Sourcing & Coordination</option><option>Partial Planning</option><option>Full Planning</option><option>Full Planning + Day-of</option><option>Day-of only</option><option>Event Design / Styling</option><option>Not sure \u2014 help me choose</option></select></div>\n<div class=\"wide\"><label>Services Needed</label><div class=\"cf-checks\"><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Venue\"> Venue</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Rentals\"> Rentals</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Balloons / Decor\"> Balloons / Decor</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Backdrop / Props\"> Backdrop / Props</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Entertainment\"> Entertainment</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Characters\"> Characters</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Bounce House / Soft Play\"> Bounce House / Soft Play</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Catering\"> Catering</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Cake / Desserts\"> Cake / Desserts</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Photographer / Videographer\"> Photographer / Videographer</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Invitations / RSVP\"> Invitations / RSVP</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Favors\"> Favors</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Signage\"> Signage</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Custom Chacin Fyre Products\"> Custom Chacin Fyre Products</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Setup / Breakdown\"> Setup / Breakdown</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Day-of Coordination\"> Day-of Coordination</label><label><input type=\"checkbox\" name=\"contact[Services Needed][]\" value=\"Other\"> Other</label></div></div>\n<div class=\"wide\"><label>Already Booked Vendors</label><textarea name=\"contact[Already Booked Vendors]\"></textarea></div><div class=\"wide\"><label>What Have You Already Purchased?</label><textarea name=\"contact[Already Purchased]\"></textarea></div><div class=\"wide\"><label>Most Important Priorities</label><textarea name=\"contact[Priorities]\"></textarea></div>\n<div class=\"wide\"><label>Inspiration Links / Photos</label><textarea name=\"contact[Inspiration Links]\" placeholder=\"Paste links here\"></textarea></div><div class=\"wide\"><label>Additional Details</label><textarea name=\"contact[body]\"></textarea></div>\n<div class=\"wide\"><label><input style=\"width:auto\" required type=\"checkbox\" name=\"contact[Acknowledgement]\" value=\"I understand that submitting this form does not reserve my event date.\"> I understand that submitting this form does not reserve my event date. *</label></div></div>\n<button class=\"cf-events-btn\" type=\"submit\">Submit Event Planning Inquiry</button><a class=\"cf-events-btn alt\" href=\"/pages/event-planning-policies\">Policies &amp; Terms</a><p>After submitting, check your inbox and spam/junk folder. Your event date is not booked until your agreement is accepted and the required non-refundable booking retainer is paid.</p></form></section>";if(h){var d=document.createElement('div');d.innerHTML=h;m.appendChild(d.firstElementChild);}});
